import { Skeleton } from '@portalterreno/react-ui-core/Skeleton';
import React from 'react';

import FixedBottomBar from '../MobileContactForm/FixedBottomBar';

const MobileContactFormSkeleton: React.FC = () => {
  return (
    <FixedBottomBar>
      <Skeleton height={48} />
    </FixedBottomBar>
  );
};

export default MobileContactFormSkeleton;
